import React from 'react';
import { HStack, Text, TextProps } from '@chakra-ui/react';
import { LOADING_ELLIPSIS_DOT_CLASS } from '@/components/ui/motion';

interface LoadingEllipsisTextProps extends TextProps {
	label: string;
}

const LoadingEllipsisText: React.FC<LoadingEllipsisTextProps> = (props) => {
	const { label, ...textProps } = props;

	return (
		<Text as="span" aria-label={`${label}...`} {...textProps}>
			<HStack as="span" gap={0} display="inline-flex" align="baseline">
				<Text as="span">{label}</Text>
				<HStack as="span" gap={0} display="inline-flex" w="0.75em" justify="flex-start" aria-hidden="true">
					<Text as="span" className={LOADING_ELLIPSIS_DOT_CLASS}>
						.
					</Text>
					<Text as="span" className={LOADING_ELLIPSIS_DOT_CLASS}>
						.
					</Text>
					<Text as="span" className={LOADING_ELLIPSIS_DOT_CLASS}>
						.
					</Text>
				</HStack>
			</HStack>
		</Text>
	);
};

export default LoadingEllipsisText;
